export const Constants = {

    SET_PRACTICE_ID: 'SET_PRACTICE_ID',
    SET_PRACTICE_PART_ID: 'SET_PRACTICE_PART_ID',
    SET_OBJECT_ID: 'SET_OBJECT_ID',
    SET_PRACTICE_TYPE: 'SET_PRACTICE_TYPE',

};